import React, { useState } from "react";
import ContextApi from "../../../HOC/ContextsAPI/ContextApi";
import Layout from "../../../HOC/layout/Layout";
import AddCategory from "../../PageComponent/CategoryData/AddCategory/AddCategory";
import ViewCategory from "../../PageComponent/CategoryData/ViewCategory/ViewCategory";
import SecondaryHeader from "../../UI/SecondaryHeader/SecondaryHeader";

function Category() {
  const [showData, setShowData] = useState("Add");
  const SearchText = () => {
    alert(4);
  };
  return (
    <ContextApi>
      <Layout>
        <div>
          <SecondaryHeader
            setShowData={setShowData}
            showData={showData}
            addBtn="AddCategory"
            viewBtn="ViewCategory"
            SearchText={SearchText}
          />
          {showData === "Add" ? <AddCategory /> : <ViewCategory />}
        </div>
      </Layout>
    </ContextApi>
  );
}

export default Category;
